import {
  type IadlItem,
  iadlAnswers,
} from '#src/terminology/instruments/instrumentTerminology.ts'
import {
  ownCoding,
  scoredItem,
  totalScore,
} from '#src/terminology/instruments/templateParts.ts'
import type {
  InstrumentSection,
  InstrumentTemplate,
} from '#src/terminology/instruments/types.ts'

const ITEMS: [IadlItem, string][] = [
  ['phone-use', 'Ability to Use Telephone'],
  ['shopping', 'Shopping'],
  ['food-preparation', 'Food Preparation'],
  ['housekeeping', 'Housekeeping'],
  ['laundry', 'Laundry'],
  ['mode-of-transportation', 'Mode of Transportation'],
  ['medication-responsibility', 'Responsibility for Own Medications'],
  ['financial-management', 'Ability to Handle Finances'],
]

const SECTIONS: InstrumentSection[] = [
  {
    id: 'items',
    items: ITEMS.map(([item, label]) =>
      scoredItem(ownCoding(`iadl-${item}`, label), iadlAnswers(item))
    ),
  },
]

// 0 (dependent) to 8 (independent); the form shows the score alone.
export const IADL_TEMPLATE: InstrumentTemplate = {
  id: 'iadl',
  version: '1',
  panel: ownCoding(
    'iadl-panel',
    'Lawton instrumental activities of daily living'
  ),
  title: 'Instrumental Activities of Daily Life Questionnaire (IADL)',
  reference: 'https://www.alz.org/careplanning/downloads/lawton-iadl.pdf',
  sections: SECTIONS,
  total: totalScore({
    templateId: 'iadl',
    coding: ownCoding('iadl-total', 'Lawton IADL total score'),
    sections: SECTIONS,
    completeness: { requireAll: true },
    bands: [],
  }),
}
